import { FilterQueryType } from "cloud-core/filters/FilterSet";
import { AnalyticsStateView } from "../../../store/analytics/Analytics";
import NumericFilter from "../../../views/viz/components/Filtering/NumericFilter";
import { Entity } from "../Entity";
import { NumberEntityProperty } from "../entityProperties/NumberEntityProperty";
import { EntityFilter } from "./EntityFilter";

export type NumericEntityFilterParameter = { minimum: number };

export class NumericEntityFilter extends EntityFilter {
    type: FilterQueryType = "numeric";
    propertyKey: string;
    maximum: number;
    isConfidence: boolean;

    constructor(displayName: string, filterRef: string, propertyKey: string, maximum?: number, isConfidence?: boolean) {
        super(displayName, filterRef);
        this.propertyKey = propertyKey;
        this.maximum = maximum ?? 100;
        this.isConfidence = isConfidence ?? false;
    }

    predicate(entities: Entity[], parameter: NumericEntityFilterParameter): Entity[] {
        console.log("NumericEntityFilter predicate", parameter);

        if (this.isConfidence) {
            return entities.filter((e) => {
                const property = e.properties[this.propertyKey] as NumberEntityProperty;
                if (!property.hasConfidence()) {
                    return false;
                }

                return parameter.minimum <= property.getConfidence();
            });
        }

        return entities.filter((e) => {
            return parameter.minimum <= (e.properties[this.propertyKey] as NumberEntityProperty).value();
        });
    }

    createComponent(filterId: string, view: AnalyticsStateView, options?: unknown): JSX.Element {
        return <NumericFilter filterId={filterId} viewId={view.viewId} maximum={this.maximum} />;
    }

    createParameterObject(parameter: NumericEntityFilterParameter): unknown {
        return {
            value: parameter.minimum,
            operator: "lte",
        };
    }

    parseParameterObject(parameterObject: unknown): NumericEntityFilterParameter {
        const obj = parameterObject as { value: number; operator: string };
        return { minimum: obj.value };
    }
}
